import { useEffect, useState } from 'react';
import { FiMessageCircle, FiUsers, FiBell, FiX } from 'react-icons/fi';
import './NotificationToast.css';

interface NotificationToastProps {
  title: string;
  message: string;
  onClose: () => void;
  onClick?: () => void;
  type?: 'chat_message' | 'new_connection' | 'admin_message' | 'event_notification' | 'connection_request_received' | 'connection_request_sent' | 'connection_accepted';
}

export function NotificationToast({ title, message, onClose, onClick, type = 'chat_message' }: NotificationToastProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
  }, []);

  const Icon = type === 'chat_message' 
    ? FiMessageCircle 
    : type === 'admin_message' || type === 'event_notification'
    ? FiBell 
    : FiUsers;

  const handleToastClick = (e: React.MouseEvent) => {
    // Don't navigate if clicking the close button
    if ((e.target as HTMLElement).closest('.notification-toast-close')) {
      return;
    }
    if (onClick) {
      onClick();
      onClose();
    }
  };

  const isClickable = !!onClick;

  return (
    <div 
      className={`notification-toast ${visible ? 'notification-toast--visible' : ''} ${isClickable ? 'notification-toast--clickable' : ''}`}
      onClick={handleToastClick}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={isClickable ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
          onClose();
        }
      } : undefined}
    >
      <div className="notification-toast-icon">
        <Icon size={20} />
      </div>
      <div className="notification-toast-content">
        <strong className="notification-toast-title">{title}</strong>
        <p className="notification-toast-message">{message}</p>
      </div>
      <button 
        className="notification-toast-close" 
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }} 
        aria-label="Cerrar notificación"
      >
        <FiX size={18} />
      </button>
    </div>
  );
}

